module.exports = new __parcel__URL__("light-mode.9ae6186d.svg").toString();